// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {createApi, fakeBaseQuery} from '@reduxjs/toolkit/query/react';

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
  baseQuery: fakeBaseQuery(),
  tagTypes: [
    'Accounts',
    'AssistantConversations',
    'AssistantUsage',
    'AssistantMemory',
    'Assets',
    'AttachmentClassifications',
    'Attachments',
    'BadgeTemplates',
    'Bulletins',
    'Clients',
    'CloudWatch',
    'ComplianceStandards',
    'CourseAssignments',
    'CourseAssignmentRules',
    'CourseAssignmentRuleExceptions',
    'CourseDefinitions',
    'CourseSessions',
    'CourseVideos',
    'Deficiencies',
    'Devices',
    'Documents',
    'DocumentReviewRules',
    'DocumentReviewRequests',
    'EquipmentTypes',
    'FormCategories',
    'FormDefinitions',
    'Forms',
    'FormTabs',
    'HangfireJobs',
    'HangfireRecurringJobs',
    'Inspections',
    'InspectionDevices',
    'InspectionSchedules',
    'InspectionTypes',
    'InstanceComplianceStandards',
    'InstanceSettings',
    'InstanceSso',
    'Instances',
    'IntegrationTokens',
    'ItemAssignments',
    'ItemDefinitions',
    'JobHazardAnalyses',
    'KnowledgeArticles',
    'Notes',
    'NotificationRules',
    'OshaEmploymentInformation',
    'OshaEstablishment',
    'OshaSummary',
    'Projects',
    'ProjectAssignments',
    'ProjectAssignmentRules',
    'ProjectAssignmentRuleExceptions',
    'ProjectRoster',
    'Personnel',
    'PersonnelBadges',
    'CourseClassrooms',
    'FormTabSubmissions',
    'ModuleExtensions',
    'Notifications',
    'PermissionSchemas',
    'Regions',
    'Reports',
    'ReportInstances',
    'RiskAssessmentCodes',
    'SafetyEvents',
    'Skills',
    'SkillSignOffs',
    'StateMachines',
    'Sites',
    'TaskAssignments',
    'TaskDefinitions',
    'UserGroups',
    'Users',
    'Vendors',
    'WorkflowDefinitions',
    'Workflows',
  ],
  endpoints: () => ({}),
});
